import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  centered: {
    textAlign: 'center',
    margin: 'auto',
    padding: '24px'
  },
  title: {
    marginBottom: '4px',
    fontWeight: 400
  },
  description: {
    marginBottom: '24px',
    padding: '0 16px'
  }
});
